/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1EmailMapping } from '../models/V1EmailMapping';
import { HttpFile } from '../http/http';

export class AdvertisingPlatformServiceUpdateEmailMappingRequest {
    'emailMapping'?: V1EmailMapping;
    'updateMask'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "emailMapping",
            "baseName": "email_mapping",
            "type": "V1EmailMapping",
            "format": ""
        },
        {
            "name": "updateMask",
            "baseName": "update_mask",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return AdvertisingPlatformServiceUpdateEmailMappingRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

